import { Model } from "@tailflow/laravel-orion/lib/model";

export class Signature extends Model<{}> {
  public $resource(): string {
    return "signatures";
  }
}
